export default "__VITE_ASSET__B1RT2R_C__"